import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  domain: [
    rules.required,
  ],
  name: [
    rules.required,
  ],
  description: [
    rules.required,
  ],
};
